<template>
    <div class="treatment">
        <div class="row">
            <div class="small-12 medium-6 columns">
                <div>
                    <label>
                        Nazvěte tento krok přípravy:
                        <input type="text" v-model="treatment.title" placeholder="např. Uvaření těstovin">
                    </label>
                    <div class="row">
                        <div class="small-12 medium-6 large-8 columns">
                            <select v-model="treatment.method_id">
                                <option value="">-- vyberte typ přípravy --</option>
                                <option
                                        :value="method.id"
                                        v-for="method in methods"
                                >
                                    {{ method.name }}
                                </option>
                            </select>
                        </div>
                        <div class="small-12 medium-6 large-4 columns">
                            <div class="input-group">
                                <input class="input-group-field text-center"
                                       type="number"
                                       v-model="treatment.time"
                                       @change="checkTreatmentTime()"
                                       @keyup="checkTreatmentTime()"
                                >
                                <span class="input-group-label"
                                      v-tooltip.bottom="{ content:'Zadejte čas v minutách' }"
                                >
                                    <i class="fa fa-clock-o"></i>
                                    &nbsp;min
                                </span>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="small-12 large-6 columns">
                            <label for="water" class="text-left middle">Jaký spotřebič použijete?</label>
                        </div>
                        <div class="small-12 large-6 columns">
                            <select v-model="treatment.appliance_id">
                                <option value="">-- vyberte spotřebič --</option>
                                <option
                                        :value="appliance.id"
                                        v-for="appliance in appliances"
                                >
                                    {{ appliance.name }}
                                </option>
                            </select>
                        </div>
                    </div>

                    <div class="row" v-show="hasWater">
                        <div class="small-12 medium-6 large-8 columns">
                            <label for="water" class="text-left middle">Jaké množství vody bude potřeba?</label>
                        </div>
                        <div class="small-12 medium-6 large-4 columns">
                            <div class="input-group">
                                <input class="input-group-field text-center"
                                       id="water"
                                       type="number"
                                       v-model="treatment.water"
                                       @change="checkTreatmentWater()"
                                       @keyup="checkTreatmentWater()"
                                >
                                <span class="input-group-label"
                                      v-tooltip.bottom="{ content:'Zadejte objem vody v mililitrech (1 litr = 1000 ml)' }"
                                >
                                    <i class="fa fa-tint"></i>
                                    &nbsp;ml
                                </span>
                            </div>
                        </div>
                    </div>

                    <label>
                        Níže můžete doplnit popis k tomuto kroku (nepovinné)
                        <textarea
                                class="autosize treatment__description"
                                v-model="treatment.description"
                                placeholder="např. Uvaříme těstoviny v osolené vodě."
                        ></textarea>
                    </label>


                    Celková váha:
                    <strong v-show="(totalWeight)">{{ totalWeight }} g</strong>
                    <span v-show="!totalWeight">-</span>
                </div>
            </div>
            <div class="small-12 medium-6 columns">

                <div class="">
                    <div style="margin-bottom: 0.7em;">
                        <img src="/themes/nutristopa/assets/img/arrow.png" style="width: 30%;" />
                    </div>
                    <strong>Vyberte ingredience</strong> pro tento krok přípravy:
                </div>

                <div class="treatment__ingredientContainer">
                    <a
                       v-for="(attachedIngredient, index) in this.ingredientsStore.state.ingredients"
                       @click="detachIngredient(index)"
                       v-show="isAttached(attachedIngredient)"
                       class="treatment__ingredient attached"
                    >
                        <span  v-text="getIngredientLabel(attachedIngredient)"></span>
                    </a>
                </div>

                <div class="treatment__ingredientContainer">
                    <a
                       v-for="(attachedIngredient, index) in this.ingredientsStore.state.ingredients"
                       @click="attachIngredient(index)"
                       v-show="isAvailable(attachedIngredient)"
                       class="treatment__ingredient available"
                    >
                        <span  v-text="getIngredientLabel(attachedIngredient)"></span>
                    </a>
                </div>
            </div>
        </div>
        <button v-on:click="$emit('remove')" class="treatment__close">x</button>
    </div>
</template>

<script>
    import _ from 'lodash';
    import autosize from 'autosize';

    import IngredientsStore from '../srores/ingredients-store.js'
    import TreatmentsStore from '../srores/treatments-store'

    export default {

        data() {
            return {
                ingredientsStore: IngredientsStore,
                treatmentsStore: TreatmentsStore,
                attachedIngredients: [],
            }
        },

        props: {
            index: {required: true},
            appliances: {required: true},
            methods: {required: true}
        },

        computed: {
            treatment() {
              return this.treatmentsStore.getTreatment(this.index)
            },
            totalWeight() {
                let totalWeight = 0;
                let water = 0;

                this.ingredientsStore.state.ingredients.forEach(ingredient => {
                    if(this.isAttached(ingredient)) {
                        totalWeight += this.getIngredientWeight(ingredient);
                    }
                });

                if (this.treatment.water) {
                    water = parseFloat(this.treatment.water)
                }

                return totalWeight + water;
            },

            hasWater() {
                //return this.treatment.method_id === 1 || this.treatment.method_id === 4;
                return this.treatment.method_id === 1;
            }
        },

        mounted() {

            autosize(document.querySelector('textarea'));
        },

        methods: {
            checkTreatmentTime() {
                if ( this.treatment.time < 0 ) {
                    this.treatment.time = 0;
                }
            },

            checkTreatmentWater() {
                if ( this.treatment.water < 0 ) {
                    this.treatment.water = 0;
                }
            },

            /**
             * Check if the specified ingredient is available for attaching
             *
             * @param ingredient
             * @return boolean
             */
            isAvailable(ingredient) {
                if (typeof ingredient.treatment === 'undefined') {
                    return true;
                }

                if (ingredient.treatment === null) {
                    return true;
                }

                return false;
            },

            /**
             * Check if specified ingredient belongs to this treatment
             *
             * @param ingredient
             * @return boolean
             */
            isAttached(ingredient) {
                if (typeof ingredient.treatment === 'undefined') {
                    return false;
                }

                if (ingredient.treatment === this.index) {
                    return true;
                }

                return false;
            },

            /**
             * Attach selected ingredient this treatment
             *
             * @param index integer
             */
            attachIngredient(index) {
                this.ingredientsStore.attachToTreatment(index, this.index);
            },

            detachIngredient(index) {
                this.ingredientsStore.detach(index);
            },

            /**
             *  Composes the label for ingredients based on selected unit and given amount
             *
             * @param ingredient
             * @returns {string}
             */
            getIngredientLabel(ingredient) {
                let unit = _.find(ingredient.ingredient.units, {id: ingredient.unit_id});

                let weight = this.getIngredientWeight(ingredient);

                if(weight === 0) {
                    return ingredient.ingredient.label;
                }

                return ingredient.ingredient.label + ' (' + weight +' g)';
            },

            getIngredientWeight(ingredient) {
                let unit = _.find(ingredient.ingredient.units, {id: ingredient.unit_id});

                if (typeof unit === 'undefined' || !ingredient.amount) {
                    return 0
                }

                return Math.round(unit.coefficient * parseFloat(ingredient.amount) * 1000) ;
            }
        }

    }
</script>

<style>
    .treatment__description {
        min-height: 80px;
    }
</style>